var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lw-404"},[_vm._v(" The resource you head for doesn't exist ")])}
var staticRenderFns = []

export { render, staticRenderFns }